import React from 'react';
import {Container, Box, LinearProgress, Stack, TableBody, TableRow, TableCell, Typography, Button} from '@mui/material';
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import PlainTable from "../../components/common/PlainTable";
import {useTranslation} from "react-i18next";
import { generateEndpoints } from '../../services/api';
const { useGetUnitTypesQuery } = generateEndpoints('unit-type');

const UnitTypesList = () => {
    const {t} = useTranslation();
    const { data: unitTypes = [], isFetching } = useGetUnitTypesQuery();

    const columns = [
        {
            title: t('Название'),
            width: '100%',
            dataKey: "model",
        },
        {
            title: t('Действия'),
            dataKey: "",
            render: (unitType) => (
                <Link to={`/settings/unit-types/${unitType.id}`}><Button variant={"outlined"}>{t('Редактировать')}</Button></Link>
            ),
        },
    ];

    return <>
        {isFetching?<LinearProgress />:
            <Box>
                <PlainTable columns={columns} data={unitTypes} />
            </Box>
        }
    </>
    ;
};

export default UnitTypesList;